// extracted by mini-css-extract-plugin
export default {"wrapper":"miniCart_wrapper__uvJ5j","icon":"miniCart_icon__5QQSg","mobile":"miniCart_mobile__lQc98","summ":"miniCart_summ__f-Hmj","count":"miniCart_count__MDBcN"};